import addPeopleTemplate from './addPeople.html';
import peopleList from './peopleList.html';

export default function AdminController($location, $scope, $rootScope, $mdDialog, AdminService, $mdToast) {
	var self = this;

	$scope.showSpinner = false;

  var getPeopleCount = function(){
    AdminService.getPeopleCount().then(function(resp){
      if(resp.data.error == ""){
        $scope.adminCount = resp.data.adminCount || 0;
        $scope.teacherCount = resp.data.teacherCount || 0;
        $scope.studentCount = resp.data.studentCount || 0;
      }
    })
  };

  getPeopleCount();

  var showToast = function(message){
    $mdToast.show(
      $mdToast.simple()
        .textContent(message)
        .position('top right')
        .hideDelay(3000)
    );
  };

  var showConfirm = function() {
    // Appending dialog to document.body to cover sidenav in docs app
    
  };

	var animateDashBoard = function(){
		setTimeout(function(){
		  $('.box').css("opacity", '1');
		  $('.box').css("transform", 'translateX(0px)');
		  $('.box').css("-webkit-transform", 'translateX(0px)');
		}, 200);
	};

	animateDashBoard();

	$scope.addPeople = function(aStatus){
    $mdDialog.show({
      template: addPeopleTemplate,
      controller: AddPeopleController,
      clickOutsideToClose:true,
      locals : {aStatus : aStatus}
    }).finally(function(){
      //Do Nothing Here
    });
  };

  $scope.listPeople = function(aStatus){
    $mdDialog.show({
      template: peopleList,
      controller: peopleListController,
      clickOutsideToClose:true,
      locals : {aStatus : aStatus}
    }).finally(function(){
      //Do Nothing Here
    });
  };

  var AddPeopleController = function($scope, $mdDialog, aStatus){
  	switch(aStatus) {
    case 'sta1':
        $scope.popStatus = 'Admin';
        break;
    case 'sta2':
        $scope.popStatus = 'Teacher';
        break;
    case 'sta3':
        $scope.popStatus = 'Student';
        break;
		}
    $scope.peopleObj = {firstName: '', lastName: '', email: '', dob:'', phone: ''};

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function() {
      if($scope.addPeopleForm.$invalid){
        angular.forEach($scope.addPeopleForm, function(val, key) {
          if (!key.match(/\$/)) {
            val.$dirty = true;
            val.$touched = true;
          }
        });
        return;
      }

      var reqObj = $scope.peopleObj;
      reqObj.pushRole = $scope.popStatus.toLowerCase();

      AdminService.savePeople(reqObj).then(function(resp){
        if(resp.data.updated){
          var toastMessage = 'New'+' '+ $scope.popStatus.toLowerCase() + ' '+ 'added successfully';
          $scope.peopleObj = {firstName: '', lastName: '', email: '', dob:'', phone: ''};
          showToast(toastMessage);
          getPeopleCount();
        }
      });
    };
  };

  var peopleListController = function($scope, $mdDialog, aStatus){

    $scope.peopleObj = {firstName: '', lastName: '', email: '', dob:'', phone: ''};
    var initialList = [];
    $scope.showSpinner = false;
  	
    switch(aStatus) {
    case 'sta1':
        $scope.popStatus = 'Admin';
        $scope.showSpinner = true;
        AdminService.getAdmins().then(function(resp){
          $scope.listPeople = resp.data.admins || [];
          initialList = $scope.listPeople;
          $scope.showSpinner = false;
        });
        break;
    case 'sta2':
        $scope.popStatus = 'Teacher';
        $scope.showSpinner = true;
        AdminService.getTeachers().then(function(resp){
          $scope.listPeople = resp.data.teachers || [];
          initialList = $scope.listPeople;
          $scope.showSpinner = false;
        });
        break;
    case 'sta3':
        $scope.popStatus = 'Student';
        $scope.showSpinner = true;
        AdminService.getStudents().then(function(resp){
          $scope.listPeople = resp.data.students || [];
          initialList = $scope.listPeople;
          $scope.showSpinner = false;
        });
        break;
		}

    var delayTimer;

    $scope.$watch('searchText', function(newValue, oldValue) {
      $scope.showSpinner = true;
      if(newValue === ""){
        $scope.listPeople = initialList;
        $scope.showSpinner = false;
      }
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function() {

          if(newValue === ""){
            console.log(initialList);
            $scope.listPeople = initialList;
            $scope.showSpinner = false;
          }
          else{
            if(newValue){
              AdminService.getStudentListByChar(newValue, $scope.popStatus.toLowerCase()).then(function(resp){
                $scope.listPeople = resp.data;
                $scope.showSpinner = false; 
              });
            }
          }
        }, 400);
      }, true);

    $scope.toggleList = function(item){
      console.log(item);
      if(item){
        $scope.peopleObj = item;
      }
      $scope.oldEmail = item.email;

      $("#example-four-slider-wrap").toggleClass("open");

    };

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function() {
      if($scope.addPeopleForm.$invalid){
        angular.forEach($scope.addPeopleForm, function(val, key) {
          if (!key.match(/\$/)) {
            val.$dirty = true;
            val.$touched = true;
          }
        });
        return;
      }

      var reqObj = $scope.peopleObj;
      reqObj.oldEmail = $scope.oldEmail;
      reqObj.newEmail = $scope.peopleObj.email;
      reqObj.pushRole = $scope.popStatus.toLowerCase();

      AdminService.updatePeople(reqObj).then(function(resp){
        if(resp.data.updated){
          var toastMessage = 'Successfully updated user profile';
          showToast(toastMessage);
          $scope.toggleList([]);
        }
      })
    };

    $scope.deletePeople = function() {
      var confirm = $mdDialog.confirm()
          .title('Are you sure?')
          .textContent('This action removes all the data related to user')
          .ariaLabel('Delete User')
          .targetEvent()
          .ok('Remove')
          .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        AdminService.deletePeople($scope.peopleObj.email, $scope.popStatus.toLowerCase()).then(function(resp){
          if(resp.data.updated){
            showToast('Deleted User from records');
            getPeopleCount();
          }
        })
      }, function() {
        //Do Nothing Here
      });
    };
  };
	
	$scope.subjectColors = ['#311B92', '#3E2723', '#263238', '#006064', '#33691E', '#BF360C', '#4A148C', '#B71C1C'];
  	$scope.subjectBorders = ['1px solid #311B92', '1px solid #3E2723', '1px solid #263238', '1px solid #006064', '1px solid #33691E', 
                          '1px solid #BF360C', '1px solid #4A148C', '1px solid #B71C1C'];
}


/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-admin/AdminController.js
 **/